import {Directive, Input, Type, ViewContainerRef} from '@angular/core';

export interface IconConfig {
    color?: string;
    size?: string;

    [key: string]: any;
}

@Directive({
    selector: '[appDynamicIcon]'
})
export class DynamicIcon {

    constructor(
        private vcr: ViewContainerRef
    ) {
    }

    @Input() set appDynamicIcon(config: { component: Type<any>, inputs?: IconConfig }) {
        const componentRef = this.vcr.createComponent(config.component);

        if (config.inputs) {
            Object.keys(config.inputs).forEach(key => {
                (componentRef.instance as any)[key] = config.inputs![key];
            });
        }
    }
}
